// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BHBY","colMin":"styles_colMin__2yBOM"};